import { useClerk } from "@clerk/react";
import { Clock } from "lucide-react";
import { useSession } from "@/context/Session";
import { t } from "@/i18n";

export function GuestBanner() {
  const { me } = useSession();
  const { signOut } = useClerk();
  if (!me.is_guest) return null;
  const when = me.guest_expires_at ? new Date(me.guest_expires_at).toLocaleString([], { weekday: "short", hour: "numeric", minute: "2-digit" }) : "";
  return (
    <div className="sticky top-14 z-30 bg-[#c2410c] text-white text-xs sm:text-sm" data-testid="guest-banner">
      <div className="max-w-7xl mx-auto px-4 py-1.5 flex items-center gap-2">
        <Clock size={14} className="shrink-0" />
        <span className="truncate">{t("Guest demo as {name}. Your questions and progress are wiped {when}.", { name: me.nickname, when })}</span>
        <button className="ml-auto underline font-semibold shrink-0" onClick={() => signOut({ redirectUrl: "/join/krusty-krab" })} data-testid="guest-leave-button">{t("Leave demo")}</button>
      </div>
    </div>
  );
}
